import type { FrequenciaRecorrencia } from '@/types/recorrencia';

// Advances an ISO datetime string by one frequency step. Mirrors the SQL in
// gerar_os_recorrentes(): semanal +7d, quinzenal +14d, mensal +1 month.
// The 'mensal' case clamps month-end exactly like Postgres `+ interval '1 month'`
// (e.g. Jan 31 -> Feb 28), so frontend and DB never disagree.
// Computes in UTC; this matches the SQL only because the DB runs in UTC.
export function avancarData(isoDate: string, frequencia: FrequenciaRecorrencia): string {
  const d = new Date(isoDate);
  switch (frequencia) {
    case 'semanal':
      d.setUTCDate(d.getUTCDate() + 7);
      break;
    case 'quinzenal':
      d.setUTCDate(d.getUTCDate() + 14);
      break;
    case 'mensal': {
      const day = d.getUTCDate();
      d.setUTCDate(1); // avoid JS month overflow before changing month
      d.setUTCMonth(d.getUTCMonth() + 1);
      const lastDay = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 0)).getUTCDate();
      d.setUTCDate(Math.min(day, lastDay));
      break;
    }
  }
  return d.toISOString();
}

// Computes the recurrence's initial proxima_data from the first OS's scheduled
// datetime. The first OS IS occurrence #1, so the recurrence generates
// occurrence #2 onward — i.e. one frequency step after the anchor.
export function proximaDataInicial(
  dataAgendada: string,
  frequencia: FrequenciaRecorrencia,
): string {
  return avancarData(dataAgendada, frequencia);
}
